import React from "react";
import "../Style/Footer.css";
import { useLanguage } from "../Context/Languagecontext";

const Footer = () => {
  const { t, lang } = useLanguage();
  const footerCopy = t.footer || {};

  const navLinks = [
    { label: footerCopy.navigation?.home || "Home", href: "/" },
    { label: footerCopy.navigation?.about || "About", href: "/about" },
    { label: footerCopy.navigation?.business || "Business", href: "/business" },
    // {
    //   label: footerCopy.navigation?.political || "Political",
    //   href: "/political",
    // },
    { label: footerCopy.navigation?.gallery || "Gallery", href: "/gallery" },
  ];

  const socialLinks = [
    {
      name: "Instagram",
      href: "https://www.instagram.com/arunkumarkkb_official/",
      icon: (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        >
          <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
          <circle cx="12" cy="12" r="4" />
          <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
        </svg>
      ),
    },
    {
      name: "Facebook",
      href: "https://www.facebook.com/arunkumar.kkb/",
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
        </svg>
      ),
    },
    {
      name: "LinkedIn",
      href: "https://www.linkedin.com/in/arun-kumar-balusamy-337227105/",
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
          <rect x="2" y="9" width="4" height="12" />
          <circle cx="4" cy="4" r="2" />
        </svg>
      ),
    },
  ];

  const ventures = [
    {
      name: "KKB Official Store",
      description:
        footerCopy.ventures?.kkb || "Woven with tradition, worn with pride",
      href: "https://www.kkbstore.com/",
    },
    {
      name: "Hindu Ara Katalai School",
      description:
        footerCopy.ventures?.hinduSchool || "Nurturing minds, shaping futures",
      href: "https://hinduglobalschool.com/",
    },
  ];

  const legacyStats = [
    {
      value: "25+",
      label: footerCopy.stats?.leadership || "Years of Leadership",
    },
    { value: "1L+", label: footerCopy.stats?.lives || "Lives Touched" },
    {
      value: "50+",
      label: footerCopy.stats?.initiatives || "Community Initiatives",
    },
    {
      value: "10+",
      label: footerCopy.stats?.institutions || "Institutions Built",
    },
  ];

  return (
    <footer className={`footer${lang === "ta" ? " footer--tamil" : ""}`}>
      {/* Decorative top border */}
      <div className="footer__top-border" aria-hidden="true">
        <span className="footer__top-border-line" />
        <span className="footer__top-border-diamond" />
        <span className="footer__top-border-line" />
      </div>

      <div className="footer__inner">
        {/* ── Signature Quote ── */}
        <div className="footer__quote-block">
          <span className="footer__quote-ornament">❝</span>
          <blockquote className="footer__quote">
            {footerCopy.quote ||
              "Greatness endures not in monuments of stone, but in the lives transformed by a single act of service."}
          </blockquote>
          <span className="footer__quote-ornament footer__quote-ornament--right">
            ❞
          </span>
          <p className="footer__quote-attr">
            — {footerCopy.quoteAuthor || "Arun Kumar Balusamy"}
          </p>
        </div>

        <div className="footer__divider" />

        {/* ── Main Grid ── */}
        <div className="footer__grid">
          {/* Identity Column */}
          <div className="footer__col footer__col--identity">
            <div className="footer__brand">
              <span className="footer__brand-pre">KKB</span>
              <span className="footer__brand-main">
                {footerCopy.brandMain || "Tradition & Legacy"}
              </span>
            </div>
            <p className="footer__tagline">
              {footerCopy.tagline ||
                "A life dedicated to community, commerce, and the timeless pursuit of excellence."}
            </p>
            <div className="footer__socials">
              {socialLinks.map((s) => (
                <a
                  key={s.name}
                  href={s.href}
                  className="footer__social-btn"
                  aria-label={s.name}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Navigation Column */}
          <div className="footer__col">
            <h4 className="footer__col-heading">
              {footerCopy.headings?.navigate || "Navigate"}
            </h4>
            <ul className="footer__nav-list">
              {navLinks.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="footer__nav-link">
                    <span className="footer__nav-arrow">›</span>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Ventures Column */}
          <div className="footer__col">
            <h4 className="footer__col-heading">
              {footerCopy.headings?.ventures || "Ventures"}
            </h4>
            <div className="footer__ventures">
              {ventures.map((v) => (
                <a
                  key={v.name}
                  href={v.href}
                  className="footer__venture-card"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="footer__venture-dot" />
                  <div>
                    <p className="footer__venture-name">{v.name}</p>
                    <p className="footer__venture-desc">{v.description}</p>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="footer__divider" />

        {/* ── Legacy Stats Strip ── */}
        <div className="footer__stats">
          {legacyStats.map((stat, i) => (
            <React.Fragment key={stat.label}>
              <div className="footer__stat">
                <span className="footer__stat-value">{stat.value}</span>
                <span className="footer__stat-label">{stat.label}</span>
              </div>
              {i < legacyStats.length - 1 && (
                <span className="footer__stat-sep" aria-hidden="true" />
              )}
            </React.Fragment>
          ))}
        </div>

        <div className="footer__divider" />

        {/* ── Closing Statement ── */}
        <div className="footer__closing">
          <p className="footer__closing-text">
            {footerCopy.closing?.line1 ||
              "Legacy is not what we leave behind —"}
            <br />
            <em>
              {footerCopy.closing?.line2 ||
                "it is what continues because we lived."}
            </em>
          </p>
        </div>
      </div>

      {/* ── Bottom Bar ── */}
      <div className="footer__bottom">
        <div className="footer__bottom-inner">
          <p className="footer__copyright">
            {footerCopy.copyright ||
              "© 2026 Arun Kumar Balusamy. All Rights Reserved."}
          </p>
          <div className="footer__bottom-links">
            <a href="/privacy" className="footer__bottom-link">
              {footerCopy.privacyPolicy || "Privacy Policy"}
            </a>
            <span className="footer__bottom-sep">·</span>
            <a href="/terms" className="footer__bottom-link">
              {footerCopy.termsOfUse || "Terms of Use"}
            </a>
          </div>
          <p className="footer__credit">
            {footerCopy.credit || "Crafted with purpose by"}{" "}
            <a
              href="https://mpeoples.in/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer__credit-link"
            >
              <span>MPeoples Business Solutions Pvt.Ltd.</span>
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
